import React from 'react';
import { Layout } from '../../components/Layout';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Section } from '../../components/ui/Section';
import { Container } from '../../components/ui/Container';
import { ShieldAlert, ExternalLink, AlertTriangle, CheckCircle } from 'lucide-react';
export function BreachCheck() {
  return <Layout data-id="element-4949">
      <Section spacing="lg" data-id="element-4950">
        <Container size="lg" data-id="element-4951">
          <div className="mb-12" data-id="element-4952">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-cyan-500/10 text-cyan-400 text-xs font-medium mb-4 border border-cyan-500/20" data-id="element-4953">
              <ShieldAlert className="h-3 w-3 mr-2" data-id="element-4954" />
              Tools Library
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4" data-id="element-4955">
              Data Breach Check
            </h1>
            <p className="text-xl text-slate-400 max-w-3xl" data-id="element-4956">
              Check if your email or phone number has been exposed in a data
              breach incident.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-4957">
            <div className="lg:col-span-2 space-y-8" data-id="element-4958">
              <section data-id="element-4959">
                <h2 className="text-2xl font-bold text-slate-100 mb-4" data-id="element-4960">
                  Recommended Tools
                </h2>
                <div className="space-y-4" data-id="element-4961">
                  <Card className="p-6" data-id="element-4962">
                    <div className="flex justify-between items-start mb-4" data-id="element-4963">
                      <h3 className="text-xl font-bold text-slate-100" data-id="element-4964">
                        Have I Been Pwned
                      </h3>
                      <span className="bg-green-500/10 text-green-400 text-xs px-2 py-1 rounded border border-green-500/20" data-id="element-4965">
                        Official Standard
                      </span>
                    </div>
                    <p className="text-slate-400 mb-6" data-id="element-4966">
                      The largest and most trusted database for checking data
                      leaks. Created by Troy Hunt (Microsoft MVP).
                    </p>
                    <a href="https://haveibeenpwned.com/" target="_blank" rel="noopener noreferrer" data-id="element-4967">
                      <Button className="w-full sm:w-auto" data-id="element-4968">
                        Check Email on HIBP
                        <ExternalLink className="ml-2 h-4 w-4" data-id="element-4969" />
                      </Button>
                    </a>
                  </Card>

                  <Card className="p-6" data-id="element-4970">
                    <div className="flex justify-between items-start mb-4" data-id="element-4971">
                      <h3 className="text-xl font-bold text-slate-100" data-id="element-4972">
                        Mozilla Monitor
                      </h3>
                      <span className="bg-green-500/10 text-green-400 text-xs px-2 py-1 rounded border border-green-500/20" data-id="element-4973">
                        Privacy Focused
                      </span>
                    </div>
                    <p className="text-slate-400 mb-6" data-id="element-4974">
                      Service from Mozilla (Firefox creators) using the HIBP
                      database but with more user-friendly mitigation guides.
                    </p>
                    <a href="https://monitor.mozilla.org/" target="_blank" rel="noopener noreferrer" data-id="element-4975">
                      <Button variant="secondary" className="w-full sm:w-auto" data-id="element-4976">
                        Check on Mozilla Monitor
                        <ExternalLink className="ml-2 h-4 w-4" data-id="element-4977" />
                      </Button>
                    </a>
                  </Card>
                </div>
              </section>

              <section className="bg-slate-900/50 p-6 rounded-lg border border-slate-800" data-id="element-4978">
                <h2 className="text-xl font-bold text-slate-100 mb-4 flex items-center" data-id="element-4979">
                  <CheckCircle className="h-5 w-5 text-cyan-500 mr-2" data-id="element-4980" />
                  Safe Usage Guidelines
                </h2>
                <ul className="space-y-3 text-slate-400" data-id="element-4981">
                  <li data-id="element-4982">• Only enter your email address or phone number.</li>
                  <li data-id="element-4983">
                    • <strong data-id="element-4984">NEVER</strong> enter your password in a breach
                    check search bar.
                  </li>
                  <li data-id="element-4985">
                    • Do not trust sites offering "Download Full Database"
                    (usually scams/malware).
                  </li>
                </ul>
              </section>
            </div>

            <div data-id="element-4986">
              <Card className="p-6 border-yellow-500/20 bg-yellow-500/5" data-id="element-4987">
                <h3 className="font-bold text-yellow-500 mb-4 flex items-center" data-id="element-4988">
                  <AlertTriangle className="h-5 w-5 mr-2" data-id="element-4989" />
                  Warning
                </h3>
                <p className="text-sm text-yellow-200/80 mb-4" data-id="element-4990">
                  Many fake sites pretend to be data breach checkers to harvest
                  active emails (phishing).
                </p>
                <p className="text-sm text-yellow-200/80" data-id="element-4991">
                  Use only the official links provided on this page.
                </p>
              </Card>
            </div>
          </div>
        </Container>
      </Section>
    </Layout>;
}